import { render, staticRenderFns } from "./PublicAnnouncement.vue?vue&type=template&id=531f6572"
import script from "./PublicAnnouncement.vue?vue&type=script&lang=js"
export * from "./PublicAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./PublicAnnouncement.vue?vue&type=style&index=0&id=531f6572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports